module.exports = __webpack_public_path__ + "img/misyon-vizyon-degerler.89512680.jpg";